import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerFotaComponent } from './dealer-fota.component';
const routes: Routes = [
  {
    path: 'dealer-fota',
    data: { name: 'Dealer FOTA', isTab: false },
    component: DealerFotaComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class dealerFotaPageRoutingModule {}
